//#region Service Imports

import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { GRID_SERVICE_NAME } from '../../../services/grid'
import { REFERENCE_TYPE_SERVICE_NAME } from '../../../services/reference-type'
import { OPERATOR_SECURITY_SERVICE_NAME } from '../../../services/operator'

//#endregion

import { LocationsMassSendConfigurationProfileController } from './locations-mass-send-configuration-profile.controller'

//#region Asset Imports

import './locations-mass-send-configuration-profile.scss'
import * as TEMPLATE from './locations-mass-send-configuration-profile.tpl.html'

//#endregion

// #region Consts

export const COMPONENT_NAME: string = 'locationsMassSendConfigurationProfile'

// #endregion

// #region Setup

export class LocationsMassSendConfigurationProfileComponent implements ng.IComponentOptions {
	controller = [
		$SCOPE_SERVICE_NAME,
		$Q_SERVICE_NAME,
		$TIMEOUT_SERVICE_NAME,
		'$sce',
		'api',
		'localDictionary',
		USER_SESSION_SERVICE_NAME,
		GRID_SERVICE_NAME,
		REFERENCE_TYPE_SERVICE_NAME,
		OPERATOR_SECURITY_SERVICE_NAME,
		LocationsMassSendConfigurationProfileController,
	]

	bindings = {
		options: '<',
	} as { [index: string]: string }

	template = TEMPLATE
}

// #endregion
